<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Create Expenditure" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="create()" ngNativeValidate>
          <app-expenditure-form [expenditure]="expenditure" *ngIf="expenditure"></app-expenditure-form>
        </form>
      </div>
    </section>
  </div>
</div>


